/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import React, { useState } from 'react';

import Button from '@atlaskit/button/default/button';
import { cssMap, jsx } from '@atlaskit/css';
import { Drawer } from '@atlaskit/drawer/drawer';
import { DrawerCloseButton } from '@atlaskit/drawer/drawer-close-button';
import { DrawerContent } from '@atlaskit/drawer/drawer-content';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';

import { Lorem } from '../lorem';

const styles = cssMap({
	buttonLayout: {
		position: 'absolute',
		insetBlockStart: token('space.200'),
		insetInlineStart: token('space.200'),
	},
	content: {
		marginBlockStart: token('space.0'),
		paddingInlineStart: token('space.300'),
		paddingInlineEnd: token('space.300'),
	},
	contentLayout: {
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		textAlign: 'center',
	},
});

export default function DrawerExample(): JSX.Element {
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);

	return (
		<React.Fragment>
			<Drawer
				isOpen={isDrawerOpen}
				label="Drawer with customized composition"
				onClose={() => setIsDrawerOpen(false)}
			>
				<div css={styles.buttonLayout}>
					<DrawerCloseButton />
				</div>
				<DrawerContent xcss={styles.content}>
					<div css={styles.contentLayout}>
						<Stack space="space.200" alignInline="center">
							<Text size="large" weight="bold">
								Centered content
							</Text>
							<Lorem count={1} />
							<Button onClick={() => setIsDrawerOpen(false)}>Close</Button>
						</Stack>
					</div>
				</DrawerContent>
			</Drawer>
			<Button appearance="primary" onClick={() => setIsDrawerOpen(true)}>
				Open drawer
			</Button>
		</React.Fragment>
	);
}
